/**
 * Automatically shrinks the font size of headings with the .resize-heading class
 * so that their text fits within their container width, preventing overflow.
 */
function resizeHeadingText() {
  const headings = document.querySelectorAll<HTMLElement>(
    '.is-style-dynamic-text-resizing'
  );
  headings.forEach(heading => {
    heading.style.removeProperty('font-size');
    const computedStyle = window.getComputedStyle(heading);
    let fontSize = parseFloat(computedStyle.fontSize);
    const minFontSize = 8; // px, minimum allowed
    // Use parent container for width comparison
    const parent = heading.parentElement;
    if (!parent) return;
    while (heading.scrollWidth > parent.offsetWidth && fontSize > minFontSize) {
      fontSize -= 1;
      heading.style.setProperty('font-size', fontSize + 'px', 'important');
    }
  });
}

// Run on page load and window resize
window.addEventListener('load', resizeHeadingText);
window.addEventListener('resize', resizeHeadingText);
